// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { previouslyPurchasedStyles } from "@pace/App/Widgets/PreviouslyPurchased/PreviouslyPurchasedTable";
import { ellipsis } from "@pace/XDL/Utilities";
import { css } from "styled-components";

previouslyPurchasedStyles.productWrapper = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};

previouslyPurchasedStyles.centeringWrapper = {
    css: css`
        text-align: center;
    `,
};

previouslyPurchasedStyles.productImage = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 90px;
                height: 90px;
            `,
        },
    },
};

previouslyPurchasedStyles.productInfo = {
    descriptionStyles: {
        productDetailLink: {
            typographyProps: {
                css: css`
                    white-space: pre-wrap;
                    ${ellipsis(2)}
                `,
            },
        },
    },
    partNumbersStyles: {
        container: {
            offsetCss: css`
                flex-direction: column;
            `,
        },
        erpNumberGridItem: {
            css: css`
                flex-direction: row;
                column-gap: 4px;
            `,
        },
        manufacturerItemGridItem: {
            css: css`
                flex-direction: row;
                column-gap: 4px;
            `,
        },
    },
};

previouslyPurchasedStyles.productActionsWithPrice = {
    goToPage: {
        typographyProps: {
            css: css`
                text-decoration: none;
            `,
        },
    },
};

previouslyPurchasedStyles.price = {
    css: css`
        min-width: 360px;
    `,
};

previouslyPurchasedStyles.noResultsContainer = {
    css: css`
        td {
            display: table-cell;
        }
    `,
};
